import { useParams, Link, Navigate } from 'react-router-dom';
import devPosts from '../data/devPosts';
import styles from './PostDetailPage.module.css';

export default function PostDetailPage() {
  const { slug } = useParams();
  const post = devPosts.find(p => p.slug === slug);

  if (!post) return <Navigate to="/dev" replace />;

  const { emoji, color, accentColor, category, title, description,
          tags, date, readTime, content } = post;

  return (
    <div>
      {/* Header */}
      <div className={styles.header} style={{ background: color }}>
        <div className="container">
          <Link to="/dev" className="back-btn">← Back to Dev Blog</Link>
          <div className={styles.headerInner}>
            <span className={styles.emoji}>{emoji}</span>
            <div className={styles.meta}>
              <span className="badge" style={{ background: accentColor }}>{category}</span>
              <span className={styles.metaItem}>📅 {date}</span>
              <span className={styles.metaItem}>⏱ {readTime}</span>
            </div>
            <h1 className={styles.title}>{title}</h1>
            <p className={styles.desc}>{description}</p>
            <div className={styles.tags}>
              {tags.map(t => <span key={t} className="tag">#{t}</span>)}
            </div>
          </div>
        </div>
      </div>

      {/* Article body */}
      <div className="container">
        <div className={styles.article}>
          {content && content.length > 0 ? (
            content.map((para, i) => (
              <p key={i} className={styles.para}>{para}</p>
            ))
          ) : (
            <div className={styles.placeholder}>
              <span className={styles.placeholderEmoji}>✍️</span>
              <h3 className={styles.placeholderTitle}>Full article coming soon!</h3>
              <p className={styles.placeholderText}>
                To add the full post: open <code className={styles.code}>src/data/devPosts.js</code>,
                find this post by slug, and add a <code className={styles.code}>content</code> array
                with your paragraphs.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
